import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import VueVideoBackground from 'vue-video-background';
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import './assets/custom.css'
Vue.component('VueVideoBackground', VueVideoBackground)
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.use(Vuetify)
Vue.use(VueSweetalert2)
Vue.use(require('vue-moment'))

   
new Vue({
  components: {VueVideoBackground},
  router,
  store,
  render: h => h(App)
}).$mount('#app')
